import { render } from "./InputDate.vue?vue&type=template&id=745d0e0d&scoped=true"
import script from "./InputDate.vue?vue&type=script&lang=js"
export * from "./InputDate.vue?vue&type=script&lang=js"

import "./InputDate.vue?vue&type=style&index=0&id=745d0e0d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-745d0e0d"]])

export default __exports__